import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import styles from "./LogModal.module.scss";

function LogModal(props: CommonModalPropsI) {
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>The event log</h2>

      <div className={styles.logs}>
        <div className={styles.log}>
          <h5>2023-02-20 | 13:00</h5>
          <p>Name change on placement 068A70 {">>"} 002CO1-007A15</p>
        </div>
        <div className={styles.log}>
          <h5>2023-02-20 | 13:00</h5>
          <p>Name change on placement 068A70 {">>"} 002CO1-007A15</p>
        </div>
        <div className={styles.log}>
          <h5>2023-02-20 | 13:00</h5>
          <p>Name change on placement 068A70 {">>"} 002CO1-007A15</p>
        </div>
        <div className={styles.log}>
          <h5>2023-02-20 | 13:00</h5>
          <p>Name change on placement 068A70 {">>"} 002CO1-007A15</p>
        </div>
      </div>
    </div>
  );
}

export default WithModal(MODALS_ENUM.LOGS_MODAL, LogModal);
